export default {"src":"/_next/static/media/Trophy.b14abaed.svg","height":32,"width":32};